export default __webpack_public_path__ + "static/media/milena_xl.308648ba.jpg";